export enum TipoPrograma {
	CURSO = 'curso',
	DIPLOMADO = 'diplomado',
	CERTIFICACION = 'certificacion',
	TALLER = 'taller',
	SEMINARIO = 'seminario',
	CONFERENCIA = 'conferencia'
}

export enum TipoAcreditacion {
	CALIFICACION = 'calificacion',
	APROBADO_REPROBADO = 'aprobado_reprobado',
	ASISTENCIA = 'asistencia'
}

export enum EscalaEvaluacion {
	CIEN = 'cien', //Ejemplo: 0 - 100
	DIEZ = 'diez', //Ejemplo: 0 - 10
	CINCO = 'cinco', //Ejemplo: 0 - 5
	PERSONALIZADA = 'personalizada' //Ejemplo: 0 - 100
}

export enum TipoComponente {
	MODULO = 'modulo',
	MATERIA = 'materia',
	COMPETENCIA = 'competencia',
	UNIDAD = 'unidad',
	BLOQUE = 'bloque'
}

export enum TipoEvaluacion {
	PARCIAL = 'parcial',
	FINAL = 'final',
	PROYECTO = 'proyecto',
	EXAMEN_UNICO = 'examen_unico',
	PRACTICA = 'practica',
	ACTIVIDAD = 'actividad',
	EVIDENCIA = 'evidencia'
}

export enum TipoValorEvaluacion {
	NUMERICO = 'numerico',
	APROBADO_REPROBADO = 'aprobado_reprobado',
	TEXTO = 'texto'
}
export enum EvaluacionNoNumerico {
	APROBADO = 'aprobado',
	NO_APROBADO = 'no_aprobado'
}
export const CEvaluacionNoNumerico: Record<EvaluacionNoNumerico, string> = {
	[EvaluacionNoNumerico.APROBADO]: 'Aprobado',
	[EvaluacionNoNumerico.NO_APROBADO]: 'No aprobado'
}
export enum EGender {
	MALE = '251',
	FEMALE = '250'
}

export const CGender: Record<EGender, string> = {
	[EGender.MALE]: 'HOMBRE',
	[EGender.FEMALE]: 'MUJER'
}
export const CGenderType: Record<EGender, string> = {
	[EGender.MALE]: 'H',
	[EGender.FEMALE]: 'M'
}

export enum EEntidadFederativa {
	AGUASCALIENTES = '01',
	BAJA_CALIFORNIA = '02',
	BAJA_CALIFORNIA_SUR = '03',
	CAMPECHE = '04',
	COAHUILA_DE_ZARAGOZA = '05',
	COLIMA = '06',
	CHIAPAS = '07',
	CHIHUAHUA = '08',
	CIUDAD_DE_MEXICO = '09',
	DURANGO = '10',
	GUANAJUATO = '11',
	GUERRERO = '12',
	HIDALGO = '13',
	JALISCO = '14',
	MEXICO = '15',
	MICHOACAN_DE_OCAMPO = '16',
	MORELOS = '17',
	NAYARIT = '18',
	NUEVO_LEON = '19',
	OAXACA = '20',
	PUEBLA = '21',
	QUERETARO = '22',
	QUINTANA_ROO = '23',
	SAN_LUIS_POTOSI = '24',
	SINALOA = '25',
	SONORA = '26',
	TABASCO = '27',
	TAMAULIPAS = '28',
	TLAXCALA = '29',
	VERACRUZ_DE_IGNACIO_DE_LA_LLAVE = '30',
	YUCATAN = '31',
	ZACATECAS = '32',
	EXTRANJERO = '33'
}

export const NOMBRE_ENTIDAD_FEDERATIVA: Record<EEntidadFederativa, string> = {
	[EEntidadFederativa.AGUASCALIENTES]: 'AGUASCALIENTES',
	[EEntidadFederativa.BAJA_CALIFORNIA]: 'BAJA CALIFORNIA',
	[EEntidadFederativa.BAJA_CALIFORNIA_SUR]: 'BAJA CALIFORNIA SUR',
	[EEntidadFederativa.CAMPECHE]: 'CAMPECHE',
	[EEntidadFederativa.COAHUILA_DE_ZARAGOZA]: 'COAHUILA DE ZARAGOZA',
	[EEntidadFederativa.COLIMA]: 'COLIMA',
	[EEntidadFederativa.CHIAPAS]: 'CHIAPAS',
	[EEntidadFederativa.CHIHUAHUA]: 'CHIHUAHUA',
	[EEntidadFederativa.CIUDAD_DE_MEXICO]: 'CIUDAD DE MÉXICO',
	[EEntidadFederativa.DURANGO]: 'DURANGO',
	[EEntidadFederativa.GUANAJUATO]: 'GUANAJUATO',
	[EEntidadFederativa.GUERRERO]: 'GUERRERO',
	[EEntidadFederativa.HIDALGO]: 'HIDALGO',
	[EEntidadFederativa.JALISCO]: 'JALISCO',
	[EEntidadFederativa.MEXICO]: 'MÉXICO',
	[EEntidadFederativa.MICHOACAN_DE_OCAMPO]: 'MICHOACÁN DE OCAMPO',
	[EEntidadFederativa.MORELOS]: 'MORELOS',
	[EEntidadFederativa.NAYARIT]: 'NAYARIT',
	[EEntidadFederativa.NUEVO_LEON]: 'NUEVO LEÓN',
	[EEntidadFederativa.OAXACA]: 'OAXACA',
	[EEntidadFederativa.PUEBLA]: 'PUEBLA',
	[EEntidadFederativa.QUERETARO]: 'QUERÉTARO',
	[EEntidadFederativa.QUINTANA_ROO]: 'QUINTANA ROO',
	[EEntidadFederativa.SAN_LUIS_POTOSI]: 'SAN LUIS POTOSÍ',
	[EEntidadFederativa.SINALOA]: 'SINALOA',
	[EEntidadFederativa.SONORA]: 'SONORA',
	[EEntidadFederativa.TABASCO]: 'TABASCO',
	[EEntidadFederativa.TAMAULIPAS]: 'TAMAULIPAS',
	[EEntidadFederativa.TLAXCALA]: 'TLAXCALA',
	[EEntidadFederativa.VERACRUZ_DE_IGNACIO_DE_LA_LLAVE]: 'VERACRUZ DE IGNACIO DE LA LLAVE',
	[EEntidadFederativa.YUCATAN]: 'YUCATÁN',
	[EEntidadFederativa.ZACATECAS]: 'ZACATECAS',
	[EEntidadFederativa.EXTRANJERO]: 'EXTRANJERO'
}

export enum EAuthorizationType {
	RVOE_FEDERAL = 1,
	RVOE_ESTATAL = 2,
	AUTORIZACION_FEDERAL = 3,
	AUTORIZACION_ESTATAL = 4,
	ACTA_DE_SESION = 5,
	ACUERDO_DE_INCORPORACION = 6,
	ACUERDO_SECRETARIAL_SEP = 7,
	DECRETO_DE_CREACION = 8,
	OTRO = 9
}

export const NOMBRE_AUTORIZACION: Record<EAuthorizationType, string> = {
	[EAuthorizationType.RVOE_FEDERAL]: 'RVOE FEDERAL',
	[EAuthorizationType.RVOE_ESTATAL]: 'RVOE ESTATAL',
	[EAuthorizationType.AUTORIZACION_FEDERAL]: 'AUTORIZACIÓN FEDERAL',
	[EAuthorizationType.AUTORIZACION_ESTATAL]: 'AUTORIZACIÓN ESTATAL',
	[EAuthorizationType.ACTA_DE_SESION]: 'ACTA DE SESIÓN',
	[EAuthorizationType.ACUERDO_DE_INCORPORACION]: 'ACUERDO DE INCORPORACIÓN',
	[EAuthorizationType.ACUERDO_SECRETARIAL_SEP]: 'ACUERDO SECRETARIAL SEP',
	[EAuthorizationType.DECRETO_DE_CREACION]: 'DECRETO DE CREACIÓN',
	[EAuthorizationType.OTRO]: 'OTRO'
}

export enum EPeriodType {
	SEMESTRE = 91,
	BIMESTRE = 92,
	CUATRIMESTRE = 93,
	TETRAMESTRE = 94,
	TRIMESTRE = 260,
	MODULAR = 261,
	ANUAL = 262
}
export const CPeriodType: { [key in EPeriodType]: string } = {
	[EPeriodType.SEMESTRE]: 'Semestre',
	[EPeriodType.BIMESTRE]: 'Bimestre',
	[EPeriodType.CUATRIMESTRE]: 'Cuatrimestre',
	[EPeriodType.TETRAMESTRE]: 'Tetramestre',
	[EPeriodType.TRIMESTRE]: 'Trimestre',
	[EPeriodType.MODULAR]: 'Modular',
	[EPeriodType.ANUAL]: 'Anual'
}

export enum EFundamentoServicioSocial {
	ART_52_LR_ART_5_CONST = 1,
	ART_55_LR_ART_5_CONST = 2,
	ART_91_RLR_ART_5_CONST = 3,
	ART_10_REGLAMENTO = 4,
	NO_APLICA = 5
}

export const NOMBRE_FUNDAMENTO_SERVICIO_SOCIAL: Record<EFundamentoServicioSocial, string> = {
	[EFundamentoServicioSocial.ART_52_LR_ART_5_CONST]: 'ART. 52 LRART. 5 CONST',
	[EFundamentoServicioSocial.ART_55_LR_ART_5_CONST]: 'ART. 55 LRART. 5 CONST',
	[EFundamentoServicioSocial.ART_91_RLR_ART_5_CONST]: 'ART. 91 RLRART. 5 CONST',
	[EFundamentoServicioSocial.ART_10_REGLAMENTO]: 'ART. 10 REGLAMENTO PARA LA PRESTACIÓN DEL SERVICIO SOCIAL DE LOS ESTUDIANTES DE LAS INSTITUCIONES DE EDUCACIÓN SUPERIOR EN LA REPÚBLICA MEXICANA',
	[EFundamentoServicioSocial.NO_APLICA]: 'NO APLICA'
}

export enum EGraduationMode {
	POR_TESIS = '1',
	POR_PROMEDIO = '2',
	POR_ESTUDIOS_POSGRADO = '3',
	POR_EXPERIENCIA_LABORAL = '4',
	POR_CENEVAL = '5',
	OTRO = '6'
}

export const NOMBRE_GRADUATION_MODE: Record<EGraduationMode, string> = {
	[EGraduationMode.POR_TESIS]: 'POR TESIS',
	[EGraduationMode.POR_PROMEDIO]: 'POR PROMEDIO',
	[EGraduationMode.POR_ESTUDIOS_POSGRADO]: 'POR ESTUDIOS DE POSGRADOS',
	[EGraduationMode.POR_EXPERIENCIA_LABORAL]: 'POR EXPERIENCIA LABORAL',
	[EGraduationMode.POR_CENEVAL]: 'POR CENEVAL',
	[EGraduationMode.OTRO]: 'OTRO'
}
export const MODALIDAD_TITULACION: Record<EGraduationMode, { modalidad: string; tipo: string }> = {
	[EGraduationMode.POR_TESIS]: {
		modalidad: 'POR TESIS',
		tipo: 'ACTA DE EXAMEN'
	},
	[EGraduationMode.POR_PROMEDIO]: {
		modalidad: 'POR PROMEDIO',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.POR_ESTUDIOS_POSGRADO]: {
		modalidad: 'POR ESTUDIOS DE POSGRADOS',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.POR_EXPERIENCIA_LABORAL]: {
		modalidad: 'POR EXPERIENCIA LABORAL',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.POR_CENEVAL]: {
		modalidad: 'POR CENEVAL',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	},
	[EGraduationMode.OTRO]: {
		modalidad: 'OTRO',
		tipo: 'CONSTANCIA DE EXCENSIÓN'
	}
}
export enum ECertificationType {
	TOTAL = 79,
	PARCIAL = 80
}

export const CTipoCertificacion: Record<ECertificationType, string> = {
	[ECertificationType.TOTAL]: 'TOTAL',
	[ECertificationType.PARCIAL]: 'PARCIAL'
}

export enum ETipoEstudioAntecedente {
	MAESTRIA = '1',
	LICENCIATURA = '2',
	TECNICO_SUPERIOR_UNIVERSITARIO = '3',
	BACHILLERATO = '4',
	EQUIVALENTE_A_BACHILLERATO = '5',
	SECUNDARIA = '6'
}

export const NOMBRE_TIPO_ESTUDIO_ANTECEDENTE: Record<ETipoEstudioAntecedente, string> = {
	[ETipoEstudioAntecedente.MAESTRIA]: 'MAESTRÍA',
	[ETipoEstudioAntecedente.LICENCIATURA]: 'LICENCIATURA',
	[ETipoEstudioAntecedente.TECNICO_SUPERIOR_UNIVERSITARIO]: 'TÉCNICO SUPERIOR UNIVERSITARIO',
	[ETipoEstudioAntecedente.BACHILLERATO]: 'BACHILLERATO',
	[ETipoEstudioAntecedente.EQUIVALENTE_A_BACHILLERATO]: 'EQUIVALENTE A BACHILLERATO',
	[ETipoEstudioAntecedente.SECUNDARIA]: 'SECUNDARIA'
}

export enum EEstatusInstitucion {
	INSCRITO = 'INSCRITO',
	EGRESADO = 'EGRESADO'
}

export const CEstatusInstitucion: Record<EEstatusInstitucion, string> = {
	[EEstatusInstitucion.INSCRITO]: 'INSCRITO',
	[EEstatusInstitucion.EGRESADO]: 'EGRESADO'
}

export enum ETipoAsignatura {
	OBLIGATORIA = 263,
	OPTATIVA = 264,
	ADICIONAL = 265,
	COMPLEMENTARIA = 266
}
export const NOMBRE_TIPO_ASIGNATURA: Record<ETipoAsignatura, string> = {
	[ETipoAsignatura.OBLIGATORIA]: 'Obligatoria',
	[ETipoAsignatura.OPTATIVA]: 'Optativa',
	[ETipoAsignatura.ADICIONAL]: 'Adicional',
	[ETipoAsignatura.COMPLEMENTARIA]: 'Complementaria'
}

export enum EObservacionAsignatura {
	EQUIVALENCIA_ESTUDIOS = 70,
	EXAMEN_EXTRAORDINARIO = 71,
	EXAMEN_TITULO_SUFI = 72,
	CURSO_VERANO = 73,
	RECURSAMIENTO = 74,
	REINGRESO = 75,
	ACUERDO_REGULARIZACION = 76,
	CAMBIO_RVOE = 77,
	REVALIDACION_ESTUDIOS = 78,
	NORMAL_ORDINARIO = 100,
	CORRESPONDENCIA_PLAN = 101,
	EXENTO = 102,
	CURSO_REGULARIZACION = 104,
	INTERCAMBIO_ACADEMICO = 105,
	EXAMEN_ULTIMA_MATERIA = 106,
	CURSO_INVIERNO = 107
}

export const OBSERVACION_ASIGNATURA_DESCRIPCION: Record<EObservacionAsignatura, string> = {
	[EObservacionAsignatura.EQUIVALENCIA_ESTUDIOS]: 'EQUIVALENCIA DE ESTUDIOS',
	[EObservacionAsignatura.EXAMEN_EXTRAORDINARIO]: 'EXAMEN EXTRAORDINARIO',
	[EObservacionAsignatura.EXAMEN_TITULO_SUFI]: 'EXAMEN A TITULO DE SUFICIENCIA',
	[EObservacionAsignatura.CURSO_VERANO]: 'CURSO DE VERANO',
	[EObservacionAsignatura.RECURSAMIENTO]: 'RECURSAMIENTO',
	[EObservacionAsignatura.REINGRESO]: 'REINGRESO',
	[EObservacionAsignatura.ACUERDO_REGULARIZACION]: 'ACUERDO REGULARIZACIÓN',
	[EObservacionAsignatura.CAMBIO_RVOE]: 'CON CAMBIO EN EL ACUERDO DE RVOE',
	[EObservacionAsignatura.REVALIDACION_ESTUDIOS]: 'REVALIDACIÓN DE ESTUDIOS',
	[EObservacionAsignatura.NORMAL_ORDINARIO]: 'NORMAL / ORDINARIO',
	[EObservacionAsignatura.CORRESPONDENCIA_PLAN]: 'CORRESPONDENCIA DE ASIGNATURA POR PLAN',
	[EObservacionAsignatura.EXENTO]: 'EXENTO',
	[EObservacionAsignatura.CURSO_REGULARIZACION]: 'CURSO DE REGULARIZACIÓN',
	[EObservacionAsignatura.INTERCAMBIO_ACADEMICO]: 'INTERCAMBIO ACADÉMICO',
	[EObservacionAsignatura.EXAMEN_ULTIMA_MATERIA]: 'EXAMEN DE ÚLTIMA MATERIA',
	[EObservacionAsignatura.CURSO_INVIERNO]: 'CURSO DE INVIERNO'
}

export enum EEstadoExpediente {
	PRE_REGISTRO = 'pre_registro',
	REGISTRO = 'registro',
	VALIDADO = 'validado',
	RECHAZADO = 'rechazado',
	CANCELADO = 'cancelado'
}

export const NOMBRE_ESTADO_EXPEDIENTE: Record<EEstadoExpediente, string> = {
	[EEstadoExpediente.PRE_REGISTRO]: 'PRE-REGISTRO',
	[EEstadoExpediente.REGISTRO]: 'REGISTRO',
	[EEstadoExpediente.VALIDADO]: 'VALIDADO',
	[EEstadoExpediente.RECHAZADO]: 'RECHAZADO',
	[EEstadoExpediente.CANCELADO]: 'CANCELADO'
}
export enum EAccionBitacora {
	CREACION = 'CREACION',
	ACTUALIZACION = 'ACTUALIZACION',
	ELIMINACION = 'ELIMINACION',
	CONSULTA = 'CONSULTA',
	EXPORTACION = 'EXPORTACION',
	IMPORTACION = 'IMPORTACION'
}
export enum ETipoBitacora {
	GENERAL = 'general',
	SYSTEM = 'system'
}
export enum ETipoPlanInstitucion {
	BASICO = 'basico',
	ESENCIAL = 'esencial',
	PROFESIONAL = 'profesional',
	INSTITUCIONAL = 'institucional'
}
export const NOMBRE_TIPO_PLAN_INSTITUCION: Record<ETipoPlanInstitucion, string> = {
	[ETipoPlanInstitucion.BASICO]: 'BÁSICO',
	[ETipoPlanInstitucion.ESENCIAL]: 'ESENCIAL',
	[ETipoPlanInstitucion.PROFESIONAL]: 'PROFESIONAL',
	[ETipoPlanInstitucion.INSTITUCIONAL]: 'INSTITUCIONAL'
}
export const LimitByPlan: Record<ETipoPlanInstitucion, number> = {
	[ETipoPlanInstitucion.BASICO]: 200,
	[ETipoPlanInstitucion.ESENCIAL]: 800,
	[ETipoPlanInstitucion.PROFESIONAL]: 1500,
	[ETipoPlanInstitucion.INSTITUCIONAL]: 3500
}

/** Alinea el valor `tipo` de API/DB (string libre) con {@link ETipoPlanInstitucion}. */
export function normalizeTipoPlanInstitucion(raw: string | ETipoPlanInstitucion | null | undefined): ETipoPlanInstitucion | null {
	if (raw == null || raw === '') return null
	const key = String(raw).trim().toLowerCase()
	for (const v of Object.values(ETipoPlanInstitucion) as ETipoPlanInstitucion[]) {
		if (v === key) return v
	}
	return null
}

/** Límite de alumnos según plan; `null` si el tipo no es reconocido. */
export function limitAlumnosPorTipoPlan(raw: string | ETipoPlanInstitucion | null | undefined): number | null {
	const tipo = normalizeTipoPlanInstitucion(raw)
	if (tipo === null) return null
	return LimitByPlan[tipo]
}
